export function getAttachmentSize(uploaded: File[]) {
  const size = uploaded.map((file) => file.size);
  const mbSize = size.reduce((a, b) => a + b, 0) / 1048576;

  return mbSize;
}
